export default {"src":"/_next/static/media/star.371b968a.svg","height":25,"width":25};